import React, { useRef, useState } from 'react';
import RecipeCard from '../RecipeCard';
import { images } from '../../assets/images';
import './RecommendedRecipes.css';
import recipeData from '../../assets/recipes';

// Sample recipe data based on Figma design

function RecommendedRecipes({ recipes = recipeData.recipes, onSelectRecipe }) {
  const gridRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);

  const handleScroll = (direction) => {
    if (!gridRef.current) return;
    if (direction === 'left') {
      setShowRight(true);
      setShowLeft(false);
    } else {
      setShowLeft(true);
      setShowRight(false);
    }
    const scrollAmount = gridRef.current.clientWidth * 1;
    gridRef.current.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  };

  return (
    <section className="recommended-recipes">
      <div className="recommended-recipes-container">
        <h2 className="recommended-recipes-title">Our Favourites</h2>
          <p className="recommended-recipes-subtitle">Enter your chef era with these flavor packed combos that are guaranteed to wow a crowd, minus the pressure!</p>
          <div className="recipes-carousel">
            {showLeft && (
              <button
              type="button"
              className="recipes-carousel-button recipes-carousel-button-left"
              aria-label="Scroll left"
              onClick={() => handleScroll('left')}
            >
              <svg width="12" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 12L12 22" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            )}
            <div className="recipes-grid" ref={gridRef}>
              {
                recipes.map((recipeItem, i) => (
                  <RecipeCard key={i} recipe={recipeItem} onSelect={onSelectRecipe} />
                ))
              }
            </div>
            {showRight && (
              <button
              type="button"
              className="recipes-carousel-button recipes-carousel-button-right"
              aria-label="Scroll right"
              onClick={() => handleScroll('right')}
            >
              <svg width="12" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 2L12 12L2 22" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            )}
            
          </div>
      </div>
    </section>
  );
}

export default RecommendedRecipes;
